// [S-060a] Friendly "not yet built" empty state for sidebar nav targets
// whose detail screens land in later stories. Spec: "Sidebar nav routes
// are placeholder stubs that 404 to a friendly empty state until the
// target story (S-061, S-061a, ...) lands."
export function NotYetBuilt({
  screen,
  story,
}: {
  screen: string;
  story: string;
}): JSX.Element {
  return (
    <div className="empty" role="status">
      <div className="empty__eyebrow">Not yet built</div>
      <h1 className="empty__title">{screen}</h1>
      <p className="empty__lede">
        This screen is on the roadmap and will arrive in <b>{story}</b>. The
        sidebar entry is a stub so the navigation graph is complete; pull up
        the Home dashboard to use the screens that already work.
      </p>
    </div>
  );
}
